export const BRAND_PERSONALITY_STEP_SIZE = 0.5;
export const BRAND_PERSONALITY_MIN_STEP_VALUE = -1;
